"use client";

import { useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { LomdaVisibilityType } from "@yedalabs/schema";

import toast from "@/lib/toast";
import { t } from "@/lib/localization";
import {
    GetLomdaV3ResponseType,
    lomdaV3QueryKey,
} from "@/features/storage/sheets/lomdaV3Sheet/hooks/useGetLomdaV3";
import { useUpdateLomdaV3 } from "../api/useUpdateLomdaV3";

// Saves who can open the lomda, then updates the one cached copy the Share card and the Embed popover read.
export const useLomdaVisibility = (
    lomdaId: string,
    visibility: LomdaVisibilityType
) => {
    const queryClient = useQueryClient();
    const { mutateAsync, isPending } = useUpdateLomdaV3(lomdaId);
    const lockRef = useRef(false);

    const setVisibility = async (next: LomdaVisibilityType) => {
        if (next === visibility || lockRef.current) return;
        lockRef.current = true;
        try {
            await mutateAsync({ visibility: next });
            queryClient.setQueryData<GetLomdaV3ResponseType>(
                lomdaV3QueryKey(lomdaId),
                (old) =>
                    old
                        ? { ...old, data: { ...old.data, visibility: next } }
                        : old
            );
        } catch {
            toast.error(t("toast.error.update-lomda"), {
                keyName: "toast.error.update-lomda",
            });
        } finally {
            lockRef.current = false;
        }
    };

    return { setVisibility, isPending };
};
